import React from "react";
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";

/**
 * "디지털 콘텐츠" 탭일 때 표시되는 서브탭
 * (소셜미디어/온라인광고/기타)
 *
 * @param {Object} props
 *  - subTabs: [{label, contentId}, ...]
 *  - currentSubTabIndex: 현재 서브탭 인덱스
 *  - onChangeSubTab: (index) => void
 */
const DigitalSubTabs = ({ subTabs, currentSubTabIndex, onChangeSubTab }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: isMobile ? "space-evenly" : "center",
        alignItems: "center",
        gap: isMobile ? "0.375rem" : "0.625rem", // 6px : 10px
        mt: isMobile ? "1rem" : "1.5rem", // 16px : 24px
        flexWrap: "wrap", // 모바일에서 줄바꿈 가능하도록 설정
      }}
    >
      {subTabs.map((subTab, index) => (
        <React.Fragment key={subTab.contentId}>
          <Box
            component="button"
            onClick={() => onChangeSubTab(index)}
            sx={{
              border: "none",
              padding: isMobile ? "0.5rem 1rem" : "0.75rem 1.5rem", // 8px 16px : 12px 24px
              cursor: "pointer",
              transition: "font-weight 0.3s ease-in-out, color 0.3s ease-in-out",
              backgroundColor: "white",
              textAlign: "center",
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontWeight: currentSubTabIndex === index ? "600" : "400",
                fontSize: isMobile ? "0.8rem" : "1.1rem", // 14px : 18px
              }}
            >
              {subTab.label}
            </Typography>
          </Box>
          {index < subTabs.length - 1 && (
            <Box
              component="span"
              sx={{
                width: "0.0625rem", // 1px
                height: isMobile ? "1.25rem" : "1.875rem", // 20px : 30px
                backgroundColor: "#ccc",
                display: "inline-block",
                margin: "0 0.375rem", // 6px 좌우 여백
              }}
            />
          )}
        </React.Fragment>
      ))}
    </Box>
  );
};

export default DigitalSubTabs;
